// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2zNC8","colMaxWidth":"Table_colMaxWidth__fC6UQ"};